import {createAction, handleActions} from 'redux-actions';
import {takeLatest} from 'redux-saga/effects';
import createRequestSaga, {createRequestActionTypes} from '../../api/createRequestSaga';
import * as feedbackAPI from '../../api/feedback';

const INITIALIZE = 'feedback/INITIALIZE';

const CHANGE_FIELD = 'feedback/CHANGE_FIELD';

const [SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAILURE] = createRequestActionTypes('feedback/SEND_FEEDBACK');

export const changeField = createAction(
    CHANGE_FIELD,
    ({ name, value }) => ({ name, value })
);

export const initialize = createAction(INITIALIZE);

export const sendFeedback = createAction(
    SEND_FEEDBACK,
    ({ answerId, type, optionList, inputText }) => ({ answerId, type, optionList, inputText })
);

const sendFeedbackSaga = createRequestSaga(SEND_FEEDBACK, feedbackAPI.sendFeedback);

export function* feedbackSaga() {
    yield takeLatest(SEND_FEEDBACK, sendFeedbackSaga);
}

const initialState = {
    optionList: [],
    inputText: '',
    feedbackResponse: null,
    feedbackError: null
};

const feedback = handleActions(
    {
        [INITIALIZE]: () => (initialState),
        [CHANGE_FIELD]: (state, {payload: { name, value }}) => ({
            ...state,
            [name]: value,
        }),
        [SEND_FEEDBACK_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            feedbackResponse: response.data
        }),
        [SEND_FEEDBACK_FAILURE]: (state, { payload: error }) => ({
            ...state,
            feedbackError: error
        })
    },
    initialState
);

export default feedback;
